











































































import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { ND, PRACOVNI_POZICE, ZAKAZKY_ESHOP_LIST, ZAKAZKY_LIST, MERGE_ZAKAZNIK, MERGE_VOZIDLO, TAB_NAMES, POLOZKY, PLANNED_ORDER_SERVICE_JOB } from '../constants';
import OZakazkaNDTable from '../nahradniDily/components/tableND.vue';
import OZakazkaPPTable from './PPTable.vue';
import PlannedOrderServiceJobTable from '../PlannedOrderServiceJob/Card.vue';
import OZakazkaOtherInfoTable from './OtherInfo.vue';
import { store } from '../store/edit';
import OzakazkaPendingItems from './OzakazkaPendingItems.vue';

export default Vue.extend({
	name: 'OZakazkaTabs',
	components: {
		OZakazkaNDTable,
		OZakazkaPPTable,
		OZakazkaOtherInfoTable,
		OzakazkaPendingItems,
		PlannedOrderServiceJobTable,
	},
	props: {
		items: { type: Object, required: true },
		storeUri: { type: String, default: null },
	},
	data() {
		return {
			PRACOVNI_POZICE,
			dependencies: {
				ND,
				PRACOVNI_POZICE,
				MERGE_ZAKAZNIK,
				MERGE_VOZIDLO,
				ZAKAZKY_LIST,
				ZAKAZKY_ESHOP_LIST,
				POLOZKY,
				PLANNED_ORDER_SERVICE_JOB,
			},
		};
	},
	computed: {
		...genVuexComputeds(store),
		tabNames(): any {
			return TAB_NAMES;
		},
	},
	methods: {
		async deleteRowClick(data:{ name:string, data:Record<string, any> }) {
			if (data.name === PRACOVNI_POZICE && data.data.SERVICE_PACKAGE_ID) {
				this.showErrorAlert({ message: 'SERVICE_PACKAGE_DELETE' });
				return false;
			}
			if (data.name === ND && data.data.SERVICE_PACKAGE_ID) {
				this.showErrorAlert({ message: 'SERVICE_PACKAGE_DELETE' });
				return false;
			}
			this.$emit('delete-click', data);
			return true;
		},
	},
});
